import { createAppAsyncThunk } from '../../store/extensions';
import { BodyPartFirstLevel, BodyPartSecondLevel, BodyType } from '../model';
import { Symptom } from './model';
import {
  deleteSymptomCall,
  fetchSecondLevelBodyPartsCall,
  fetchSymptomsByTypeCall,
  fetchSymptomsCall,
  insertSymptomsCall,
  searchSymptomsByBodyPartCall,
  searchSymptomsCall,
  updateSymptomCall,
} from './service';

export const searchSymptoms = createAppAsyncThunk(
  'healthJourney/getSymptomsBySearch',
  (searchString: string) => {
    return searchSymptomsCall(searchString);
  }
);

export const fetchSymptoms = createAppAsyncThunk(
  'healthJourney/getSymptoms',
  (healthJourneyId: string) => {
    return fetchSymptomsCall(healthJourneyId);
  }
);

export const fetchSymptomsByType = createAppAsyncThunk(
  'healthJourney/getSymptomsByType',
  (arg: { healthJourneyId: string; symptomType: string }) => {
    return fetchSymptomsByTypeCall(arg.healthJourneyId, arg.symptomType);
  }
);

export const insertSymptoms = createAppAsyncThunk(
  'healthJourney/insertSymptoms',
  (newSymptom: Symptom[]) => {
    return insertSymptomsCall(newSymptom);
  }
);

export const updateSymptom = createAppAsyncThunk(
  'healthJourney/updateSymptom',
  (symptom: Symptom) => {
    return updateSymptomCall(symptom);
  }
);

export const deleteSymptom = createAppAsyncThunk(
  'healthJourney/deleteSymptom',
  (symptomId: string) => {
    return deleteSymptomCall(symptomId);
  }
);

export const searchSymptomsByBodyPart = createAppAsyncThunk(
  'healthJourney/fetchSymptomsByFirstLevelBodyPart',
  (arg: {
    bodyType: BodyType;
    front: boolean;
    bodyPartFirstLevel: BodyPartFirstLevel;
    bodyPartSecondLevel: BodyPartSecondLevel;
  }) => {
    return searchSymptomsByBodyPartCall(
      arg.bodyType,
      arg.front,
      arg.bodyPartFirstLevel,
      arg.bodyPartSecondLevel
    );
  }
);

export const fetchSecondLevelBodyParts = createAppAsyncThunk(
  'healthJourney/fetchSecondLevelBodyParts',
  (arg: {
    bodyType: BodyType;
    front: boolean;
    bodyPartFirstLevel: BodyPartFirstLevel;
  }) => {
    return fetchSecondLevelBodyPartsCall(
      arg.bodyType,
      arg.front,
      arg.bodyPartFirstLevel
    );
  }
);
